import React, {useState} from 'react';
import emailjs from 'emailjs-com';
import './contactUs.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//muestra el formulario de contacto, y envia un email tanto al propietario de la pagina como al usuario!
export default function ContactUs() {
const [show, setShow] = useState(false)
  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_xd2kwkn', 'template_yxye7vo', e.target, 'user_8XeoRFh1fdyr5EO0ZuprE')
      .then((result) => {
          toast.info(`👌📧 ${result.text}`);
        setShow(true)
      }, (error) => {
          toast.error(error.text);
      });
  }

  return (
    <>
    <section className="contenedor-formulario">
      <form className="contact-form" onSubmit={sendEmail}>
      {show ?
      <p className='pronto'>Pronto nos pondremos en Contacto contigo</p>
      :
       <> <input type="hidden" name="contact_number" />
        <label>Nombre y Apellido</label>
        <input type="text" name="user_name" />
        <label>Email</label>
        <input type="email" name="user_email" />
        <label>Mensaje</label>
        <textarea name="message" />
        <input className="btn-enviar-form" type="submit" value="Send" /></>}
      </form>
    </section>
    <ToastContainer/>
    </>
  );
}